import React from "react";
import Helmet from "react-helmet";
import styled from "styled-components";
import Link from "gatsby-link";
import { Title, CenteredFull } from "../components/Typography";
import { Card, Strong, colors, Text, Button } from "evergreen-ui";
import Img from "gatsby-image";
import Flex, { FlexItem } from "styled-flex-component";
import _ from "lodash";

class TagRoute extends React.Component {
	render() {
		const posts = this.props.data.tags.edges;
		const tag = this.props.pathContext.tag;
		const totalCount = this.props.data.tags.totalCount;
		const tagHeader = `${totalCount} post${totalCount === 1 ? "" : "s"} tagged with “${tag}”`;

		console.log(posts);

		return (
			<section className="section">
				<Helmet title={tag} />
				<CenteredFull>
					<Title>{tagHeader}</Title>
				</CenteredFull>
				<Grid>
					{posts.map(post => {
						if (post.node.fields) {
							return (
								<Link to={post.node.fields.slug}>
									<Card elevation={1} key={post.node.fields.slug}>
										<Flex alignCenter full>
											<FlexItem style={{ alignSelf: "flex-start" }}>
												{post.node.frontmatter.featured_image && (
													<BlogImage resolutions={post.node.frontmatter.featured_image.childImageSharp.resolutions} />
												)}
											</FlexItem>
											<FlexItem style={{ padding: "1rem" }}>
												<Flex column>
													<Strong size={700}>
														{_.truncate(post.node.frontmatter.title, { length: 60, separator: " " })}
													</Strong>
													<Strong size={200} color={colors.green}>
														{post.node.frontmatter.date}
													</Strong>
													<Text>{_.truncate(post.node.frontmatter.description, { length: 60, separator: " " })}</Text>
												</Flex>
											</FlexItem>
										</Flex>
									</Card>
								</Link>
							);
						} else {
							return "";
						}
					})}
					<Button style={{ justifySelf: "flex-start" }}>
						<Link to="/tags/">Browse all tags</Link>
					</Button>
				</Grid>
			</section>
		);
	}
}

const BlogImage = styled(Img)`
	margin-right: 15px;
	border-radius: 10px;

	@media screen and (max-width: 600px) {
		width: 80px !important;
		height: 80px !important;
		border-radius: 5px;
	}
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fit, 500px);
	grid-gap: 35px 50px;
	justify-content: center;
	margin-bottom: 5rem;

	@media screen and (max-width: 500px) {
		grid-template-columns: repeat(auto-fit, calc(100vw / 24 * 22));
		grid-gap: 25px 0;
	}
`;

export default TagRoute;

export const tagPageQuery = graphql`
	query TagPage($tag: String) {
		tags: allMarkdownRemark(
			limit: 1000
			sort: { fields: [frontmatter___date], order: DESC }
			filter: { frontmatter: { tags: { in: [$tag] } } }
		) {
			totalCount
			edges {
				node {
					fields {
						slug
					}
					frontmatter {
						title
						description
						date(formatString: "MMMM DD, YYYY")
						featured_image {
							childImageSharp {
								resolutions(width: 165, height: 165) {
									...GatsbyImageSharpResolutions_withWebp
								}
							}
						}
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/tags.jsx